import { TableProps } from '@slal/ui/layout';
import { StyledTable } from './styles';

export const Table = (props: TableProps) => <StyledTable striped={false} {...props} />;
